"use strict";

module.exports = require("./dist/videosdk-ui-toolkit.min.umd");
